<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-layout justify-center wrap py-8>
          <v-flex xs12>
            <v-card>
              <v-flex xs12>
                <v-card color="#434343" outlined class="mx-auto">
                  <v-layout justify-center wrap pt-3 pb-5 v-if="school">
                    <v-flex xs12 sm12 md12 text-center>
                      <v-layout justify-center wrap>
                        <v-flex xs12>
                          <v-avatar style="cursor: pointer" size="80">
                            <v-img :src="mediaURL + school.image" />
                          </v-avatar>
                        </v-flex>
                        <v-flex xs12 pt-1>
                          <span
                            style="
                              color: #ffffff;
                              font-family: nunitosanssemibold;
                              font-size: 18px;
                            "
                            >{{ school.name }} </span
                          ><br />
                          <span
                            style="
                              font-family: nunitosansbold;
                              color: #ffffff;
                              font-size: 12px;
                            "
                            >{{ school.address }}</span
                          >
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-layout justify-center wrap v-if="admin.length > 0">
                <v-flex xs12>
                  <v-card-text>
                    <v-layout justify-start px-5 wrap py-5>
                      <v-flex xs12 sm12 md6>
                        <span
                          style="
                            color: #000000;
                            font-family: nunitosansbold;
                            font-size: 18px;
                          "
                          >Admins</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout justify-start wrap>
                      <v-flex
                        xs12
                        sm6
                        md4
                        lg4
                        xl4
                        v-for="(list, index) in admin"
                        :key="index"
                        pa-2
                      >
                        <v-card>
                          <v-card-text>
                            <v-layout justify-center wrap>
                              <v-flex xs10 sm10 md10 lg9>
                                <span
                                  v-if="list.school"
                                  style="
                                    color: #000000;
                                    font-family: nunitosansbold;
                                  "
                                  >{{ list.school.name }}</span
                                ><br />
                                <span
                                  style="
                                    color: #000000;
                                    font-family: nunitosanssemibold;
                                  "
                                  >{{ list.name }}</span
                                ><br />
                                <span
                                  style="
                                    color: #000000;
                                    font-family: nunitosanssemibold;
                                  "
                                  >{{ list.phone }}</span
                                >
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  //   props: ["id"],
  data() {
    return {
      hover: false,
      appLoading: false,
      ServerError: false,
      editdialog: false,
      menu: false,
      cgpi: 50,
      admin: [],
      school: [],
      file1: null,
      genders: ["Male", "Female", "Other"],
    };
  },
  mounted() {
    this.getData();
    this.getList();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/school/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.query.school,
        },
      })
        .then((response) => {
          this.school = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getList() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/school/admin/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          school: this.$route.query.school,
        },
      })
        .then((response) => {
          this.admin = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.heading {
  color: #4d4d4d;
  font-family: nunitosanslight;
  font-size: 12px;
}
.content {
  color: #000000;
  font-family: nunitosansregular;
}
.subject {
  color: #4d4d4d;
  font-family: nunitosansregular;
  font-size: 12px;
}
</style>